import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';
import Logo from '../assets/img/OnesoftLogo.png';
import contactInfo from '../constants/contactInfo.json';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="footer-grid">
          <div className="footer-col">
            <Link to="/" className="brand">
              <div className="logo-container">
                <img src={Logo} alt="OneSoft Logo" className="logo-image" />
              </div>
            </Link>
            <p className="footer-desc">
              ONESOFT is a privately owned company focussing on providing IT consulting services,
              offshore web development and software development, re-engineering solutions and
              ready-to-deploy business applications for various industries.
            </p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/verticals">Verticals</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <div className="footer-contact-list" style={{ display: 'flex', flexDirection: 'column', gap: '15px', color: 'var(--text-secondary)', fontSize: '14px' }}>
              {contactInfo.addresses.map((address) => (
                <div key={address} style={{ display: 'flex', gap: '12px' }}>
                  <MapPin size={18} className="text-gradient" style={{ flexShrink: 0 }} />
                  <span>{address}</span>
                </div>
              ))}
              {contactInfo.phones.map((phone) => (
                <div key={phone} style={{ display: 'flex', gap: '12px' }}>
                  <Phone size={18} className="text-gradient" />
                  <a href={`tel:${phone}`}>{phone}</a>
                </div>
              ))}
              <div style={{ display: 'flex', gap: '12px' }}>
                <Mail size={18} className="text-gradient" />
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <h4>Newsletter</h4>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '15px' }}>
              Subscribe to stay updated with our latest news.
            </p>
            <div className="footer-newsletter">
              <input type="email" placeholder="Email Address" className="ghost-btn small" style={{ width: '100%', marginBottom: '10px', textAlign: 'left' }} />
              <button className="primary-btn small" style={{ width: '100%' }}>Subscribe</button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} OneSoft Systems Pvt Ltd. All rights reserved.</p>
          <div className="social-links" style={{ display: 'flex', gap: '15px' }}>
            <a href="#" aria-label="Facebook" className="icon-wrapper" style={{ width: '36px', height: '36px' }}>{React.createElement(FaFacebook as any, { size: 18 })}</a>
            <a href="#" aria-label="Twitter" className="icon-wrapper" style={{ width: '36px', height: '36px' }}>{React.createElement(FaTwitter as any, { size: 18 })}</a>
            <a href="#" aria-label="LinkedIn" className="icon-wrapper" style={{ width: '36px', height: '36px' }}>{React.createElement(FaLinkedin as any, { size: 18 })}</a>
            <a href="#" aria-label="GitHub" className="icon-wrapper" style={{ width: '36px', height: '36px' }}>{React.createElement(FaGithub as any, { size: 18 })}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
